import { create } from 'zustand';

const CAMP_STORAGE_KEY = 'camp';

const getStoredCamp = () => {
    try {
        const stored = sessionStorage.getItem(CAMP_STORAGE_KEY);
        return stored ? JSON.parse(stored) : null;
    } catch {
        return null;
    }
};

const useCampStore = create((set) => ({
    campId: getStoredCamp()?.campId || null,
    campName: getStoredCamp()?.campName || null,
    campCode: getStoredCamp()?.campCode || null,
    orgInviteToken: getStoredCamp()?.orgInviteToken || null,

    setCamp: (data) => {
        const campData = {
            campId: data.campId || data.id,
            campName: data.campName || data.name,
            campCode: data.campCode || data.code,
            orgInviteToken: data.orgInviteToken,
        };
        sessionStorage.setItem(CAMP_STORAGE_KEY, JSON.stringify(campData));
        set(campData);
    },

    clearCamp: () => {
        sessionStorage.removeItem(CAMP_STORAGE_KEY);
        set({
            campId: null,
            campName: null,
            campCode: null,
            orgInviteToken: null,
        });
    },
}));

export default useCampStore;
